import React, { FC } from 'react';
import styled from 'styled-components';

import i18n from 'i18n';
import Typography from 'components/v2/Typography';
import { FontIcon } from 'components/v2/FontIcon';
import Layout from '../../components/v2/Layout/index';

const NotFoundContainer = styled.div`
  background: var(--sys-color--surface);
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 24px;
  height: 100%;
  width: 100%;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
  max-width: 320px;
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: var(--sys-color--surface-container-high, rgba(17, 37, 48, 0.05));
  color: var(--sys-color--on-surface);
  margin-bottom: 8px;
`;

const NotFoundContent = () => (
  <NotFoundContainer>
    <Content>
      <IconContainer>
        <FontIcon name="search_off" size={36} />
      </IconContainer>
      <Typography variant="titleLarge" color="var(--sys-color--on-surface)">
        {i18n('page.NotFound.NotFoundText')()}
      </Typography>
    </Content>
  </NotFoundContainer>
);

const NotFoundPage: FC = () => {
  return (
    <Layout
      center={i18n('page.Error.center')()}
      name="NotFound"
      pageElement={<NotFoundContent />}
    />
  );
};

export default NotFoundPage;
